import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { PostDraftInterface } from '../interfaces/post.interface';
import type { TextBlock } from '../interfaces/textEditor.interface';

const textBlocksInitialState: TextBlock = {
  id: '',
  type: undefined,
  data: {
    paragraph: '',
    header: '',
    level: 0,
    items: [],
    file: undefined,
    code: '',
    withBorder: false,
    withBackground: false,
    stretched: false,
    caption: '',
    style: 'unordered',
  },
};

export const postReplyDraftsSlice = createSlice({
  name: 'postReplyDraftsStore',
  initialState: {
    postReplyDrafts: [],
    textBlocks: [textBlocksInitialState],
    refetchDrafts: false,
    refetchPostReplyDrafts: false,
  },
  reducers: {
    GET_ALL_POST_REPLY_DRAFTS_INIT: (state) => {
      state.postReplyDrafts = [];
    },
    SET_POST_REPLY_DRAFTS_STORE_ACTION: (state, action: PayloadAction<any>) => {
      state.postReplyDrafts = action.payload;
    },
    UPDATE_POST_REPLY_DRAFTS_STORE_ACTION: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.postReplyDrafts = action.payload;
    },
    UPDATE_POST_REPLY_DRAFT_STORE_ACTION: (
      state,
      action: PayloadAction<{
        postReplyDraftId: string;
        updatedDraft: PostDraftInterface;
      }>,
    ) => {
      const { postReplyDraftId, updatedDraft } = action.payload;
      const draftIndex = state.postReplyDrafts.findIndex(
        (postReplyDraft: PostDraftInterface) =>
          postReplyDraft.id === postReplyDraftId,
      );
      if (draftIndex !== -1) {
        // @ts-ignore
        state.postReplyDrafts[draftIndex] = {
          // @ts-ignore
          ...state.postReplyDrafts[draftIndex],
          ...updatedDraft,
        };
      }
    },
    RESET_POST_REPLY_DRAFTS_STORE_ACTION: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.postReplyDrafts = [];
      state.textBlocks = [textBlocksInitialState];
    },
    DELETE_POST_REPLY_DRAFT: (
      state,
      action: PayloadAction<PostDraftInterface[]>,
    ) => {
      (state.postReplyDrafts as PostDraftInterface[]) = action.payload;
    },
    REFETCH_POST_REPLY_DRAFTS: (state, action: PayloadAction<boolean>) => {
      state.refetchPostReplyDrafts = action.payload;
    },
  },
});

export default postReplyDraftsSlice.reducer;
